// sfide.ts — le chiamate HTTP del gioco (crea, leggi, revoca, server ICE, segnala) e i token delle sfide
// salvati sul telefono, così ricaricando la pagina si rientra nella propria partita.
import { richiesta } from "./api.ts";
import { idDispositivo } from "./dispositivo.ts";
import { leggiPreferenza, salvaPreferenza } from "./preferenze.ts";
import { PREFERENZE } from "../costanti.ts";

export interface SfidaCreata {
  codice: string;
  token: string;
  link: string;
  scadeIl: string;
}
export interface InfoSfida {
  nome: string;
  /** Avatar di chi sfida (v019), null = non scelto. */
  avatar?: number | null;
  stato: "aperta" | "in_corso";
  scadeIl: string;
}
export interface ServerIce {
  urls: string[];
  username?: string;
  credential?: string;
}
import type { MotivoSegnalazione } from "../../../condiviso/segnalazioni.ts";
export { MOTIVI_SEGNALAZIONE, type MotivoSegnalazione } from "../../../condiviso/segnalazioni.ts";

const enc = encodeURIComponent;

export function creaSfida(nome: string, avatar?: number): Promise<SfidaCreata> {
  return richiesta<SfidaCreata>("/api/v1/sfide", { metodo: "POST", corpo: { nome, dispositivo: idDispositivo(), ...(avatar ? { avatar } : {}) } });
}
export function leggiSfida(codice: string): Promise<InfoSfida> {
  return richiesta<InfoSfida>(`/api/v1/sfide/${enc(codice)}`);
}
export function revocaSfida(codice: string, token: string): Promise<void> {
  return richiesta<void>(`/api/v1/sfide/${enc(codice)}/revoca`, { metodo: "POST", corpo: { token } });
}
export function serverIce(codice: string, token: string): Promise<{ iceServers: ServerIce[]; turn: boolean }> {
  return richiesta(`/api/v1/sfide/${enc(codice)}/ice`, { metodo: "POST", corpo: { token } });
}
export function segnala(codice: string, token: string, motivo: MotivoSegnalazione, nota: string): Promise<void> {
  return richiesta<void>(`/api/v1/sfide/${enc(codice)}/segnala`, {
    metodo: "POST",
    corpo: { token, motivo, ...(nota.trim() ? { nota: nota.trim() } : {}) },
  });
}

// --- token salvati sul telefono ---------------------------------------------------------
interface Salvate {
  /** per: sfida mandata dal link personale di qualcuno (si aspetta che accetti lui, niente link da condividere). */
  [codice: string]: { token: string; il: number; per?: string };
}
// Oltre la scadenza massima di un link (sfide.scadenza_minuti ≤ 7 giorni) più un giorno di gioco: poi la sfida è finita.
const DURATA_TOKEN_MS = 8 * 24 * 3600 * 1000;

function salvate(): Salvate {
  try {
    const v = JSON.parse(leggiPreferenza(PREFERENZE.sfide) ?? "{}") as Salvate;
    return typeof v === "object" && v !== null ? v : {};
  } catch {
    return {};
  }
}

export function tokenSalvato(codice: string): string | null {
  return salvate()[codice]?.token ?? null;
}

export function salvaToken(codice: string, token: string, per?: string): void {
  const ora = Date.now();
  const s = Object.fromEntries(Object.entries(salvate()).filter(([, v]) => ora - v.il < DURATA_TOKEN_MS));
  // Chi rientra (la stanza conferma il token) non perde il "per" salvato quando la sfida è stata mandata.
  const p = per ?? s[codice]?.per;
  s[codice] = { token, il: ora, ...(p ? { per: p } : {}) };
  salvaPreferenza(PREFERENZE.sfide, JSON.stringify(s));
}

/** Nome di chi deve accettare una sfida mandata dal suo link personale (null = sfida normale). */
export function sfidaPer(codice: string): string | null {
  return salvate()[codice]?.per ?? null;
}

export function dimenticaToken(codice: string): void {
  const s = salvate();
  delete s[codice];
  salvaPreferenza(PREFERENZE.sfide, JSON.stringify(s));
}
